import SignupSvg from './SignupSvg';
import {LocaleSelect} from 'shared/components';

const BrandedContainer = ({header, info, children}) => {
  return (
    <div className='branded-container table relative'>
      <div className='table-cell align-middle center sm-and-below-hide'>
        <div className='MarketingCopyContainer mx-auto'>
          <div className='p4'>
            <div className='h2'>
              {header}
            </div>
            <div className='pt2 jumbo center'>
              {info}
            </div>
          </div>
          <SignupSvg/>
        </div>
      </div>
      <div className='BrandedFormContainer table-cell align-middle'>
        <div className='absolute right' style={{top: '28px', right: '80px'}}>
          <LocaleSelect/>
        </div>
        <div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default BrandedContainer;
